import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * ─── ProtectedRoute (with role support) ───
 *
 * Checks:
 *   1. Is user logged in? If not → /login
 *   2. Does user have the required role? If not → / (home)
 *
 * Usage:
 *   <ProtectedRoute requiredRole="admin"><Admin /></ProtectedRoute>
 */

function ProtectedRoute({ children, requiredRole }) {
  const { user, role, loading } = useAuth();

  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;
